import { PageParams } from '../repositories/common/types/createOfflineCommonRepository.types';
import { offlineSellersRepository } from '../repositories/offlineSellers.repository';
import { OfflineDatabaseSellerTransformer } from '../transformers/OfflineDatabaseSeller.transformers';
import { OfflinePaginatedParamsWithQuery } from './types/common.types';

const page = async ({ limit, skip, query }: OfflinePaginatedParamsWithQuery) => {
  const params: PageParams = query ? { limit, skip, query } : { limit, skip };
  const pageOfflineSellers = await offlineSellersRepository.page(params);
  const customers = pageOfflineSellers.data.map(OfflineDatabaseSellerTransformer.toOnlineSeller);
  return {
    data: customers,
    count: pageOfflineSellers.count,
  };
};

export const sellersRepositoryOfflineAdapters = {
  page,
};
